import React from 'react';
import { connect } from 'react-redux';

import Authorized from './ui/screens/authorized/router';
import Onboarding from './ui/screens/onboarding/router';
import Unauthorized from './ui/screens/unauthorized/router';
import Connect from './ui/screens/connect/router';

import SplashScreen from './ui/screens/splash';
import 'react-medium-image-zoom/dist/styles.css';
import { useHistory } from 'react-router-dom';

const App = ({ appReady, isAuthenticated, isOnboarding, connectId }) => {
  const Ready = () => {
    const History = useHistory();
    if (!appReady) return <SplashScreen />;

    if (isAuthenticated && connectId) {
      History.push(`/connect/${connectId}`);
    }

    return isAuthenticated ? (
      connectId ? (
        <Connect />
      ) : isOnboarding ? (
        <Onboarding />
      ) : (
        <Authorized />
      )
    ) : (
      <Unauthorized />
    );
  };

  return <Ready />;
};

const mapStateToProps = (state) => {
  return {
    appReady: state.App.isReady,
    isOnboarding: state.Auth.session?.user?.is_onboarding,
    isAuthenticated: state.Auth.isAuthenticated,
    connectId: state.Connect.id,
  };
};

export default connect(mapStateToProps)(App);
